export default "__VITE_ASSET__CGUUe9_j__"